import { render } from "./WinAlert.vue?vue&type=template&id=28c29bc6&scoped=true"
import script from "./WinAlert.vue?vue&type=script&lang=js"
export * from "./WinAlert.vue?vue&type=script&lang=js"

import "./WinAlert.vue?vue&type=style&index=0&id=28c29bc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c29bc6"]])

export default __exports__